module.exports = __webpack_public_path__ + "img/youtube.54d9264c.png";